import { motion } from "framer-motion";
import { useEffect } from "react";

const TITLE = "ROYAL TATTOO".split("");

export default function SplashScreen({ onComplete }) {
  useEffect(() => {
    const t = setTimeout(onComplete, 3200);
    return () => clearTimeout(t);
  }, [onComplete]);

  return (
    <motion.div
      data-testid="splash-screen"
      className="fixed inset-0 z-[100] bg-[#0A0A0A] flex flex-col items-center justify-center gap-6"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.8, ease: "easeInOut" }}
    >
      {/* SVG Crown */}
      <motion.svg
        viewBox="0 0 100 65"
        className="w-24 h-16 md:w-32 md:h-20"
        fill="none"
      >
        {/* Crown outline */}
        <motion.path
          d="M8,60 L8,46 L22,18 L37,34 L50,6 L63,34 L78,18 L92,46 L92,60 Z"
          stroke="#C9A84C"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{ pathLength: 1, opacity: 1 }}
          transition={{ duration: 1.4, ease: "easeInOut", delay: 0.2 }}
        />
        {/* Base line */}
        <motion.line
          x1="8" y1="60" x2="92" y2="60"
          stroke="#C9A84C"
          strokeWidth="1.5"
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{ pathLength: 1, opacity: 1 }}
          transition={{ duration: 0.4, delay: 1.6 }}
        />
        {/* Jewels */}
        {[
          { cx: 50, cy: 6, r: 3 },
          { cx: 22, cy: 18, r: 2.2 },
          { cx: 78, cy: 18, r: 2.2 },
        ].map((jewel, i) => (
          <motion.circle
            key={i}
            cx={jewel.cx}
            cy={jewel.cy}
            r={jewel.r}
            fill="#C9A84C"
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 1.8 + i * 0.1, duration: 0.3 }}
          />
        ))}
      </motion.svg>

      {/* Letters */}
      <div className="flex items-center gap-[0.05em] overflow-hidden">
        {TITLE.map((char, i) => (
          <motion.span
            key={i}
            className="font-cormorant text-3xl md:text-4xl tracking-[0.25em] text-[#C9A84C]"
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              delay: 1.6 + i * 0.05,
              duration: 0.4,
              ease: "easeOut",
            }}
          >
            {char === " " ? "\u00A0\u00A0" : char}
          </motion.span>
        ))}
      </div>

      {/* Subline */}
      <motion.p
        className="text-[#888888] text-xs tracking-[0.4em] uppercase font-outfit"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2.4, duration: 0.6 }}
      >
        Grevenbroich · Leverkusen
      </motion.p>

      {/* Bottom line */}
      <motion.div
        className="absolute bottom-0 left-0 h-[1px] bg-[#C9A84C]/30"
        initial={{ width: "0%" }}
        animate={{ width: "100%" }}
        transition={{ delay: 0.5, duration: 2.5, ease: "easeInOut" }}
      />
    </motion.div>
  );
}
